import { YMaps } from '@pbe/react-yandex-maps';
import type { FC } from 'react';
import { Fragment, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import { Product } from '@src/constants';
import { StepWizardForm } from '@src/features';
import { useComponentsConfig, useResetFlatSteps } from '@src/hooks';
import {
  AuthActionTypes,
  PresetSettingActionTypes,
  Store,
  UserActionTypes,
  WizardActionTypes,
} from '@src/store';
import { ComponentsConfigType } from '@src/types';

import { useAnalyticsIfl } from './hooks';

export const IFLFlatForm: FC = () => {
  const {
    state: {
      stateWizard: { currentStep },
      stateFormIFLFlat: { presetData },
      statePresetSetting: { isPresetSettingDisplayed },
      stateUser: { agentLogin },
    },
    dispatch,
  } = useContext(Store);
  const { components } = useComponentsConfig(
    Product.APARTMENT,
    !!presetData ? ComponentsConfigType.MAIN : ComponentsConfigType.DEFAULT
  );

  const navigate = useNavigate();

  useAnalyticsIfl();

  const goBack = () => {
    if (currentStep === 1) {
      dispatch({
        type: AuthActionTypes.SetConfirmationId,
        payload: undefined,
      });

      dispatch({
        type: AuthActionTypes.SetAuthenticationToken,
        payload: undefined,
      });

      dispatch({
        type: UserActionTypes.SetCachedPhoneNumber,
        payload: undefined,
      });

      dispatch({
        type: UserActionTypes.SetAuthenticationRefetchUid,
        payload: uuidv4(),
      });

      navigate('/login');
    } else {
      navigate(-1);
    }
  };

  const maxStep = components?.length || 0;

  useEffect(() => {
    if (isPresetSettingDisplayed) {
      dispatch({
        type: WizardActionTypes.SetCurrentStep,
        payload: maxStep,
      });
      dispatch({
        type: PresetSettingActionTypes.SetIsPresetSettingDisplayed,
        payload: false,
      });
    }
  }, []);

  return isPresetSettingDisplayed ? null : (
    <YMaps>
      <StepWizardForm
        scrollToIframeOnChange
        maxStep={maxStep}
        useResetSteps={!!presetData ? undefined : useResetFlatSteps}
        goBack={goBack}
        isAgreementWithButton={!agentLogin}
      >
        {components?.map((Component, index) => {
          if (currentStep === index + 1) {
            return (
              <Fragment key={index}>
                <Component />
              </Fragment>
            );
          }
          return null;
        })}
      </StepWizardForm>
    </YMaps>
  );
};
